// This allows us to load Angular components on legacy server-side pages.
import {
  Component,
  Injector,
  NgModuleFactory,
  NgModuleFactoryLoader,
  OnInit,
  SkipSelf,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import '../app/rxjs-operators';
import { components } from './components';

@Component({
  selector: 'webapp-compat',
  template: `
    <ng-container #entryPoint></ng-container>
    <fl-modal></fl-modal>
  `,
})
export class CompatComponent implements OnInit {
  @ViewChild('entryPoint', { read: ViewContainerRef })
  entryPoint: ViewContainerRef;

  constructor(
    @SkipSelf() private injector: Injector,
    private loader: NgModuleFactoryLoader,
  ) {}

  ngOnInit() {
    components
      // Only bootstrap the components on the page
      .filter(({ selector }) => document.getElementsByTagName(selector)[0])
      .forEach(({ selector, loadChildren, component, path }) =>
        this.loader
          .load(loadChildren)
          .then((ngModuleFactory: NgModuleFactory<any>) => {
            // NgModuleFactory
            const componentFactory = ngModuleFactory
              .create(this.injector) // ngModuleRef
              .componentFactoryResolver.resolveComponentFactory(component);
            if (path === 'hack_path_not_used_index_0') {
              this.entryPoint.createComponent(componentFactory, 0);
            } else {
              this.entryPoint.createComponent(componentFactory);
            }
          }),
      );
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/zh/webapp/src/compat/compat.component.ts